export default __webpack_public_path__ + "locales/en/SMTPSettings.json?hash=e6a4d6b749bcf544e3dd2f440572f682";